import { all, call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { pushNotification } from "utils/notifications";
import {
  getGPSHistoricalData,
  getRXData,
  getVideoSnapshot,
  getMapPlaces,
  createQuery,
  getLocationProfile,
  getUsersList,
  getUsersAggregateList,
  getPageList,
  getCudbLocationList,
  getMediaList,
} from "../services/apis/collections/oAuthApis";
import {
  GET_HISTORICAL_GPS,
  GET_RX,
  GET_VIDEO_SNAPSHOT,
  GET_MAP_PLACES_BOUNDS,
  GET_MAP_PLACES_FILTER,
  GET_PAGE_PLACES_FILTER,
  GET_LOCATION_PROFILES,
} from "reducers/dashboardReducer";

function* GetGPSHistoricalDataAPI(action) {
  try {
    const { requestData, live, imei, messageId } = action.payload;
    console.log("message id", messageId);
    const response = yield call(getGPSHistoricalData, requestData);
    if (response && response.status) {
      yield put({
        type: "ADD_GPS",
        payload: { response, live, imei, messageId },
      });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function formatForRedis(text = "cudb-client") {
  return text.replace(/-|_|\./g, function (x) {
    return `\\${x}`;
  });
}

function getResponseData(type, response) {
  let responseData;
  switch (type) {
    case "user":
      responseData = response.data
        ?.filter((user) => {
          return user.email && user.phone && typeof user.objectIds === "number";
        })
        ?.map((user) => {
          // console.log("user profile", user?.profile);
          return {
            id: user.objectIds.toString(),
            name: user?.profile?.firstName + " " + user.profile?.lastName,
            firstName: user?.profile?.firstName ?? "",
            lastName: user?.profile?.lastName ?? "",
            gender: user?.profile?.gender ?? "",
            dob: user?.profile?.dob ?? "",
            email: user.email,
            phone: user.phone,
            beamId: `${user?.profile?.firstName?.toLowerCase()}.${user?.profile?.lastName?.toLowerCase()}`,
            objectType: type,
            location: user?.profile?.location?.coordinates
              ? {
                  coordinates: [
                    user?.profile?.location.coordinates.long,
                    user?.profile?.location.coordinates.lat,
                  ],
                }
              : undefined,
          };
        });
      break;
    case "page":
      responseData = response.data.map((page) => ({
        id: page.objectIds.toString(),
        name: page?.persistent?.static.metadata.title,
        objectType: type,
        location: page?.persistent?.static?.live?.location?.coordinates
          ? {
              coordinates: [
                page?.persistent?.static?.live?.location.coordinates.long,
                page?.persistent?.static?.live?.location.coordinates.lat,
              ],
            }
          : undefined,
      }));
      break;
  }
  return responseData;
}

function getRequestData(type, inputQueryId, serviceId) {
  let requestData;
  switch (type) {
    case "user":
      requestData = {
        objectType: type,
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: `@serviceId:{'${formatForRedis(serviceId)}'}`,
            searchOptions: "TIMEOUT 1000",
          },
          list: {
            inputQueryId,
          },
          load: {
            email: "$..live.alternativeIds.email",
            phone: "$..live.alternativeIds.phone",
            profile: "$..profile",
            latitude: "$..profile.location.coordinates.lat",
            longitude: "$..profile.location.coordinates.long",
            serviceId: "$.serviceId",
          },
        },
        groupBy: {
          properties: [
            "@email",
            "@profile",
            "@phone",
            "@latitude",
            "@longitude",
            "@serviceId",
          ],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@objectId"],
              name: "objectIds",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "@latitude > 0 && @longitude > 0",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 100,
          },
        },
        anyStatus: false,
      };
      break;

    case "page":
      requestData = {
        objectType: type,
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:pageUpdatedAtIndex`,
            searchQuery: `@pageType:{'event'}@pageMembers:{'${localStorage.getItem(
              "RID"
            )}'}`,
            searchOptions: "TIMEOUT 1000",
          },
          list: {
            inputQueryId,
          },
          load: {
            persistent: "$.persistent",
            latitude: "$.persistent.static.live.location.coordinates.lat",
            longitude: "$.persistent.static.live.location.coordinates.long",
          },
        },
        groupBy: {
          properties: ["@persistent", "@latitude", "@longitude"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@objectId"],
              name: "objectIds",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 100,
          },
        },
        filter: {
          expression: "@latitude > 0 && @longitude > 0",
        },
        anyStatus: false,
      };
      break;

    case "gps":
      break;

    case "place":
      break;

    case "asset":
      break;

    case "media":
      break;

    case "event":
      break;
  }
  return requestData;
}

function* GetMapPlacesDataAPI(action) {
  try {
    // const responseQuery = yield call(createQuery, { data: { changes: [] } });
    // console.log("response query here", responseQuery);
    const response = yield call(getMapPlaces, {
      ...action.payload.request,
      // outputQueryId: responseQuery?.data?.id,
    });
    console.log("response here", response);

    // console.log("enabled here");

    if (response && response.data) {

      yield put({ type: "ADD_MAP_PLACES_BOUNDS", payload: response.data });

      // const userRequest = getRequestData(
      //   "user",
      //   responseQuery?.data?.id,
      //   action.payload.serviceId
      // );
      // let userResponse = yield call(getUsersAggregateList, {
      //   data: userRequest,
      // });
      // userResponse = getResponseData("user", userResponse) || [];

      // const pageRequest = getRequestData(
      //   "page",
      //   responseQuery?.data?.id,
      //   action.payload.serviceId
      // );
      // let pageResponse = yield call(getUsersAggregateList, {
      //   data: pageRequest,
      // });
      // pageResponse = getResponseData("page", pageResponse) || [];

      // const gpsRequest = getRequestData(
      //   "gps",
      //   responseQuery?.data?.id,
      //   action.payload.serviceId
      // );
      // let gpsResponse = yield call(getUsersAggregateList, {
      //   data: pageRequest,
      // });
      // pageResponse = getResponseData("page", pageResponse) || [];

      // yield put({
      //   type: "ADD_MAP_PLACES_BOUNDS",
      //   payload: [...userResponse, ...pageResponse],
      // });
    } else {
      yield put({ type: "ADD_MAP_PLACES_BOUNDS", payload: [] });
    }
  } catch (error: any) {
    console.log(error);
    yield put({ type: "ADD_MAP_PLACES_BOUNDS", payload: [] });
  }
}

function* GetRXDataAPI(action) {
  try {
    const { id } = action.payload;
    const response = yield call(getRXData, id);
    if (response && response.status) {
      yield put({ type: "ADD_RX", payload: response.meta_data });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* GetVideoSnapshotDataAPI(action) {
  try {
    const { id } = action.payload;
    const response = yield call(getVideoSnapshot, id);
    if (response && response.length > 0) {
      yield put({ type: "ADD_VIDEO_SNAPSHOT", payload: response[0] });
    } else {
      console.log("waiting...");
      yield put({ type: "ADD_VIDEO_SNAPSHOT", payload: { success: false } });
    }
  } catch (error) {
    console.log(error);
    yield put({ type: "ADD_VIDEO_SNAPSHOT", payload: { success: false } });
  }
}

function* GetMapPlacesFilterDataAPI(action) {
  try {
    const { objectType } = action.payload;
    let response;
    if (
      objectType === "user" ||
      objectType === "gps" ||
      objectType === "page" ||
      objectType === "place" ||
      objectType === "gps" ||
      objectType === "asset"
    ) {
      response = yield call(getUsersAggregateList, {
        data: action.payload,
      });
    }
    // else if (objectType === "page") {
    //   response = yield call(getPageList, {
    //     data: action.payload,
    //   });
    // } else if (objectType === "place" || objectType === "asset") {
    //   response = yield call(getCudbLocationList, {
    //     data: action.payload,
    //   });
    // }
    else if (objectType === "media" || objectType === "event") {
      const pageListResponse = yield call(getUsersAggregateList, {
        data: {
          select: {
            index: {
              searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:pageTitleIndex`,
              searchQuery: `@pageMembers:{${localStorage.getItem("RID")}}`,
              searchOptions: "TIMEOUT 1000",
            },
            list: {},
            load: {
              serviceId: "$.serviceId",
            },
          },
          groupBy: {
            properties: ["@serviceId"],
            reducers: [
              {
                func: "TOLIST",
                arguments: ["@objectId"],
                name: "objectIds",
              },
            ],
          },
          apply: {
            expression: "",
            name: "",
          },
          result: {},
          filter: {
            expression: "",
          },
          anyStatus: false,
        },
      });

      const objectIds = pageListResponse?.data?.[0]?.objectIds || [];

      console.log("page list response ", pageListResponse);

      if (objectType === "media") {
        response = yield call(getMediaList, {
          data: {
            ...action.payload,
            searchQuery: `@pageId:{${objectIds.join("|")}}`,
          },
        });
      } else {
        const requestData = { ...action.payload };
        requestData.select.index.searchQuery = `@type:{event}@pageId:{${objectIds.join(
          "|"
        )}}`;
        response = yield call(getUsersAggregateList, {
          data: requestData,
        });
      }
    }
    // const response = yield call(getMapPlacesFilter, action.payload);
    if (response && response.data) {
      let responseData = response.data;

      if (objectType === "media") {
        responseData = response.data
          .map((item: { [x: string]: any[] }) => ({
            id: Object.keys(item)[0],
            obj: item[Object.keys(item)[0]][0],
          }))
          .filter(
            (item: { obj: {} }) => item.obj && Object.keys(item.obj).length > 0
          );
      }

      console.log("respnse data", responseData);

      if (objectType === "user" || objectType === "gps") {
        // responseData = responseData.map((item: { id: any; obj: any[] }) => ({
        //   id: item.id,
        //   name: item.obj?.[0]?.persistent?.static.live
        //     ? item.obj[0].persistent?.static?.live?.profile?.firstName +
        //       " " +
        //       item.obj[0].persistent?.static?.live?.profile?.lastName
        //     : "",
        //   objectType,
        //   location: item.obj?.[0]?.persistent?.static?.live?.profile?.location
        //     ?.coordinates
        //     ? {
        //         coordinates: [
        //           item.obj?.[0]?.persistent?.static?.live?.profile?.location
        //             .coordinates.long,
        //           item.obj?.[0]?.persistent?.static?.live?.profile?.location
        //             .coordinates.lat,
        //         ],
        //       }
        //     : undefined,
        // }));

        responseData = response.data
          ?.filter((user) => {
            return user.email || user.phone;
          })
          ?.map((user) => {
            // console.log("user profile", user?.profile);
            return {
              id: user.objectIds.toString(),
              name: user?.profile?.firstName + " " + user.profile?.lastName,
              firstName: user?.profile?.firstName ?? "",
              lastName: user?.profile?.lastName ?? "",
              gender: user?.profile?.gender ?? "",
              dob: user?.profile?.dob ?? "",
              email: user.email,
              phone: user.phone,
              beamId: `${user?.profile?.firstName?.toLowerCase()}.${user?.profile?.lastName?.toLowerCase()}`,
              objectType,
              location: user?.profile?.location?.coordinates
                ? {
                    coordinates: [
                      user?.profile?.location.coordinates.long,
                      user?.profile?.location.coordinates.lat,
                    ],
                  }
                : undefined,
            };
          });
      } else if (objectType === "page") {
        responseData = responseData.map((page) => ({
          id: page.objectIds.toString(),
          name: page?.persistent?.static.metadata.title,
          objectType,
          location: page?.persistent?.static?.live?.location?.coordinates
            ? {
                coordinates: [
                  page?.persistent?.static?.live?.location.coordinates.long,
                  page?.persistent?.static?.live?.location.coordinates.lat,
                ],
              }
            : undefined,
        }));
      } else if (objectType === "place") {
        responseData = responseData.map((place) => ({
          id: place.objectIds.toString(),
          name: place?.persistent?.static?.poi?.location?.attributes?.title,
          objectType,
          location: place?.persistent?.static?.poi?.location?.coordinates
            ? {
                coordinates: [
                  place?.persistent?.static?.poi?.location.coordinates.long,
                  place?.persistent?.static?.poi?.location.coordinates.lat,
                ],
              }
            : undefined,
        }));
      } else if (objectType === "asset") {
        responseData = responseData.map((place) => ({
          id: place.objectIds.toString(),
          name: place?.persistent?.static?.asset?.location?.attributes?.title,
          objectType,
          location: place?.persistent?.static?.asset?.location?.coordinates
            ? {
                coordinates: [
                  place?.persistent?.static?.asset?.location.coordinates.long,
                  place?.persistent?.static?.asset?.location.coordinates.lat,
                ],
              }
            : undefined,
        }));
      } else if (objectType === "event") {
        responseData = responseData.map((event) => ({
          id: event.objectIds.toString(),
          name: event?.message?.attributes?.body,
          objectType,
          location: event?.message?.attributes?.location?.coordinates
            ? {
                coordinates: [
                  event?.message?.attributes?.location.coordinates.long,
                  event?.message?.attributes?.location.coordinates.lat,
                ],
              }
            : undefined,
        }));
      } else if (objectType === "media") {
        responseData = responseData.map((item: { id: any; obj: any[] }) => ({
          id: item.id,
          name: item.obj?.[0]?.originalName,
          objectType,
          location: item.obj?.[0]?.info?.location?.coordinates
            ? {
                coordinates: [
                  item.obj?.[0]?.info?.location.coordinates.long,
                  item.obj?.[0]?.info?.location.coordinates.lat,
                ],
              }
            : undefined,
          urls: item.obj?.[0]?.urls,
        }));
      }
      responseData = responseData.filter((user) => {
        return user.location !== undefined;
      });
      console.log("response", responseData);
      yield put({
        type: `ADD_MAP_${action.payload.objectType.toUpperCase()}_FILTER`,
        payload: responseData || [],
      });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}


function* GetMapPageFilterDataAPI(action) {
  try {
    const { requestData, callback } = action.payload;
    const {objectType} = requestData;
    const response = yield call(getUsersAggregateList, {
      data: requestData,
    });

    if (response && response.data) {
      let responseData = response.data;

    

      console.log("respnse data", responseData);

        responseData = responseData.map((item) => ({
          id: item?.objects?.objectId,
          name: item.objects?.message?.attributes?.body,
          objectType,
          messageType: item.objects?.message?.type,
          location: item.objects?.message?.attributes?.coordinates
            ? {
                coordinates: [
                  item.objects?.message?.attributes?.coordinates?.long,
                  item.objects?.message?.attributes?.coordinates?.lat,
                ],
              }
            : (
              item.objects?.message?.attributes?.location?.coordinates ? 
              {
                coordinates: [
                  item.objects?.message?.attributes?.location?.coordinates?.long,
                  item.objects?.message?.attributes?.location?.coordinates?.lat,
                ],
              }: undefined
            ),
          data: item.objects?.message?.attributes,
          settings: item.objects?.message?.attributes,
          ...item?.objects?.pageInfo,
          urls: item.objects?.message?.attributes?.urls
        }));

      responseData = responseData.filter((user) => {
        return user.location !== undefined;
      });
      console.log("response", responseData);
      yield put({
        type: `ADD_MAP_${objectType.toUpperCase()}_FILTER`,
        payload: responseData || [],
      });
      if(callback)callback(responseData)
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}


function* GetLocationProfilesDataAPI(action) {
  try {
    const response = yield call(getLocationProfile, action.payload);
    console.log("location profile response", response);
    if (response && response.data) {
      yield put({ type: "SET_LOCATION_PROFILES", payload: response.data });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* watchGetRequest() {
  yield takeEvery(GET_HISTORICAL_GPS, GetGPSHistoricalDataAPI);
  yield takeEvery(GET_RX, GetRXDataAPI);
  yield takeEvery(GET_VIDEO_SNAPSHOT, GetVideoSnapshotDataAPI);
  yield takeEvery(GET_MAP_PLACES_BOUNDS, GetMapPlacesDataAPI);
  yield takeEvery(GET_MAP_PLACES_FILTER, GetMapPlacesFilterDataAPI);
  yield takeEvery(GET_PAGE_PLACES_FILTER, GetMapPageFilterDataAPI);
  yield takeEvery(GET_LOCATION_PROFILES, GetLocationProfilesDataAPI);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
